import {
  Config,
  LogEntriesConstantsEnums,
  LogEntryPriorityEnum,
  LogEntryTypesEnums
} from '@nw/shared/config';

import { getServerDateFormat } from './DateTimeUtils';
import { captureSentryException } from './SentryUtils';
import { getUserInfoDetails, UserDetailsType } from './UserInfoUtils';

export interface LogDataType extends UserDetailsType {
  event_name?: string;
  time_stamp?: number | string;
  log_type: LogEntryTypesEnums;
  priority: LogEntryPriorityEnum;
}

interface LogObject {
  primaryObject: LogDataType;
}

const isNotDevEnvironment =
  process.env.NODE_ENV !== 'development' ||
  window.location.hostname !== 'localhost';

let isLogEntriesInitialized = false;

const logEntriesDataLayer: Array<LogObject> = [];

export const getLogEntriesInstance = () => {
  if (Config.LOGENTRIES_TOKEN) {
    return window['LE'];
  }
  return {
    log: () => {},
    init: () => {}
  };
};

const sendDataToLogEntries = (logData: LogDataType) => {
  getLogEntriesInstance().log(logData);
};

export function pushLogEntriesToR7() {
  logEntriesDataLayer.forEach((event) =>
    sendDataToLogEntries(event.primaryObject)
  );
}

export function initializeLogEntries() {
  const logEntries = getLogEntriesInstance();
  try {
    if (isNotDevEnvironment && logEntries) {
      logEntries.init({
        token: Config.LOGENTRIES_TOKEN,
        region: 'eu',
        no_format: true,
        trace: true,
        page_info: 'per-entry'
      });
      isLogEntriesInitialized = true;
      pushLogEntriesToR7();
    }
  } catch (error) {
    console.log(error);
    isLogEntriesInitialized = false;
  }
}
export function captureLogEntriesExceptionWithScope(
  errorInfo: LogEntriesConstantsEnums,
  error: Record<string, any>,
  logType: LogEntryTypesEnums,
  priority: LogEntryPriorityEnum
) {
  const timeStamp: number | string = getServerDateFormat(new Date());

  const primaryObject: LogDataType = {
    event_name: errorInfo,
    log_type: logType,
    ...getUserInfoDetails(),
    ...error,
    time_stamp: timeStamp,
    priority
  };
  if (isLogEntriesInitialized) {
    try {
      if (isNotDevEnvironment) {
        sendDataToLogEntries(primaryObject);
      }
    } catch (error) {
      captureSentryException(new Error('CAPTURE_LOG_ENTRIES_FAILED'), error);
    }
  } else {
    logEntriesDataLayer.push({
      primaryObject: primaryObject
    });
  }
}
